import React, { useState } from 'react';
import styled from 'styled-components';
import { SortedItem } from '../../@types/coupon';
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation';
import { CustomRadio, SortItem, SortItemWrap } from '../product/ProductSortModal';

// 이미지 경로
const imgURL = '/images';

export default function CouponSubmit({
  setIsModal,
  submitKeyword,
  setSubmitKeyword,
}: {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  submitKeyword: string;
  setSubmitKeyword: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [closing, setClosing] = useState<boolean>(false);
  const sortItem: SortedItem[] = [
    { label: '전체', value: 'RECENT_PRODUCT', desc: 'DESC' },
    { label: '상품쿠폰', value: 'DISCOUNT', desc: 'DESC' },
    { label: '주문쿠폰', value: 'DISCOUNT', desc: 'DESC' },
  ];
  const closeModal = () => {
    setClosing(true);
    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 300);
  };
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>쿠폰 유형</p>
          <button className="btn_close" onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          <SortItemWrap>
            {sortItem.map((el: any) => {
              return (
                <>
                  <SortItem key={el.value}>
                    <CustomRadio>
                      <input
                        type="radio"
                        value={el.value}
                        name="radioBtn"
                        id={el.label}
                        onChange={() => {
                          setSubmitKeyword(el.label);
                          closeModal();
                        }}
                        checked={submitKeyword === el.label}
                      />
                      <label
                        htmlFor={el.label}
                        style={{
                          fontWeight: submitKeyword === el.label ? '600' : '500',
                          color: submitKeyword === el.label ? 'var(--colBlack)' : 'var(--colGray6)',
                        }}
                      >
                        {el.label}
                      </label>
                      <span className="checkmark"></span>
                    </CustomRadio>
                  </SortItem>
                </>
              );
            })}
          </SortItemWrap>
        </ModalBody>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}
interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 900;
`;

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18.5px 22px 0 33px;
  align-items: center;
  gap: 8px;
  & p {
    flex: 1;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    span {
      display: inline-block;
      color: var(--colPointBlue);
      margin-left: 4px;
    }
  }
  & button {
    border: none;
    background: transparent;
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    & img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 8px 33px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 33px;
`;
